<template>
  <div>
    <div v-show="!isPortrait" class="demo-game-ui">
      <player
        :video-plr="video"
        :is-mission="isPlayLoyalty"
        :is-control-scene="false"
        :mission-details="missionDetails"
        @showTutorial="showTutorial"
        @itemHint="itemHint"
        :is-hint-item="isHintItem"
        @pauseVideo="() => plyr.pause()"
        ref="videogameplayer"
      >
        <template v-slot:ads>
          <div class="snackbar-parent">
            <!-- <button type="button" @click="AddBrading">Add Brading</button> -->
            <transition-group name="list" tag="ul">
              <li v-for="item in listItemSnackBar" :key="item.id" class="item">
                <img :src="item.thumnail" :alt="item.name" />
                {{ item.name }}
              </li>
            </transition-group>
          </div>
          <!-- <TransitionGroup
            class="snackbar-parent"
            tag="ul"
            style="list-style-type: none"
            name="list"
          >
            <li
              v-for="(item, index) in listItemSnackBar"
              :key="index"
              class="item-snackbar"
            >
              {{ item.name }}
            </li>
          </TransitionGroup> -->

          <div v-for="(shop, idxShop) in shops" :key="idxShop">
            <div
              v-if="shop.id === missionDetails.id"
              class="movingElement"
              :id="shop.id + 'item'"
              :style="{
                left: shop.x + 'px',
                top: shop.y + 'px',
                width: shop.width + 'px',
                height: shop.height + 'px',
              }"
            >
              <div
                @click="onclickBuyNow(shop)"
                :id="shop.id"
                :class="shop.id"
                style="position: relative; width: 100%; height: 100%"
              >
                <div v-if="isHintItem" class="hint-item">
                  <v-icon>{{ mdiMapMarkerAlertOutline }}</v-icon>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:tutorial>
          <div v-if="isShowTutorial" class="tutorial-zone">
            <div class="title-tutorial">Hướng dẫn hoàn thành nhiệm vụ</div>
            <div class="main-zone-tutorial">
              <div class="box-tutorial">
                <span>Bước 1</span>
                <img src="../../../assets/Step1.jpg" alt="" />
                <div class="text-tutorial">Xem Nội Dung</div>
              </div>
              <div class="box-tutorial">
                <span>Bước 2</span>
                <img src="../../../assets/Step2.jpg" alt="" />
                <div class="text-tutorial">
                  Bấm vào sản phẩm phù hợp với yêu cầu của nhiệm vụ
                </div>
              </div>
              <div class="box-tutorial">
                <span>Bước 3</span>
                <img src="../../../assets/Step3.jpg" alt="" />
                <div class="text-tutorial">
                  Sau khi hoàn thành nhiệm vụ, bạn sẽ được nhận VieStar và có
                  thể đi đổi quà
                </div>
              </div>
            </div>
            <button @click="closeTutorial" class="button-play-now">
              Bắt đầu xem
            </button>
          </div>
        </template>
        <template v-slot:pointAward>
          <div class="award-point-zone">
            <span> +{{ pointDetails }} </span>
            <img src="../../../assets/starpoint.png" alt="" />
          </div>
        </template>
      </player>
    </div>
    <div v-if="isPortrait" class="isLandscape-image">
      <div class="phone">
        <img src="../../../assets/vieon.png" alt="Vieon" />
      </div>
      <div class="message">Please rotate your device!</div>
    </div>
  </div>
</template>

<script>
import {
  mdiSeal,
  mdiDiscAlert,
  mdiMapMarkerAlertOutline,
  mdiClose,
  mdiSealVariant,
} from "@mdi/js";

import { playerShowcase } from "../../../minxin/player-showcase-v2";
import _ from "lodash";
import Player from "../components/Player";

import award from "./award.json";

export default {
  components: { Player },
  mixins: [playerShowcase],
  data() {
    return {
      mdiSeal: mdiSeal,
      mdiDiscAlert: mdiDiscAlert,
      mdiSealVariant: mdiSealVariant,
      mdiMapMarkerAlertOutline: mdiMapMarkerAlertOutline,
      mdiClose: mdiClose,
      showShopInfo: null,
      reload: 0,
      point: 0,
      isPlayLoyalty: true,
      listAward: award,
      itemLeft: 0,
      itemTop: 0,
      itemHeight: 0,
      itemWidth: 0,
      pointDetails: 0,
      myMission: [],
      missionDetails: {},
      listItem: [],
      isShowTutorial: true,
      isHintItem: false,
      timeStartPrint: [],
      videogameplayer: null,
      isPortrait: false,
      listItemSnackBar: [],
      next: 1,
      listBradingDefault: [
        {
          id: 1,
          name: "The Coffee House",
          thumnail:
            "https://order.thecoffeehouse.com/_nuxt/img/squarelogo.035676b.png",
        },
        {
          id: 2,
          name: "Highlands coffee",
          thumnail:
            "https://cdn.haitrieu.com/wp-content/uploads/2022/03/Logo-HighLands-Coffee.png",
        },
        {
          id: 3,
          name: "Adidas",
          thumnail:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Adidas_Logo.svg/1000px-Adidas_Logo.svg.png",
        },
        {
          id: 4,
          name: "Nike",
          thumnail:
            "https://substackcdn.com/image/fetch/f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fbucketeer-e05bbc84-baa3-437e-9518-adb32be77984.s3.amazonaws.com%2Fpublic%2Fimages%2F67979fc2-9bc6-4ef1-a91a-9f8129c57645_1500x1500.jpeg",
        },
        {
          id: 5,
          name: "Honda",
          thumnail: "https://cdn3.dhht.vn/wp-content/uploads/2022/07/4.jpg",
        },
      ],
    };
  },
  computed: {},
  created() {
    switch (this.$vuetify.breakpoint.name) {
      case "lg":
        this.showPrPanel = true;
        this.slotPanel = true;
        break;
      case "xl":
        this.showPrPanel = true;
        this.slotPanel = true;
        break;
      default:
        this.showPrPanel = false;
        this.slotPanel = false;
        break;
    }
  },
  mounted() {
    this.myMission = JSON.parse(localStorage.getItem("MyMission")) || [];
    this.missionDetails =
      JSON.parse(localStorage.getItem("MissionDetails")) || [];
    document.getElementById("footer").style.display = "none";
    this.applyOrientation();
    window.onresize = () => {
      this.applyOrientation();
    };

    setInterval(() => {
      if (Math.floor(Math.random() * 4) % 2 === 0) {
        this.insert(
          this.listItemSnackBar,
          this.listBradingDefault[Math.floor(Math.random() * 4)]
        );
      } else {
        this.insert(
          this.listItemSnackBar,
          this.listBradingDefault[Math.floor(Math.random() * 4)]
        );
        setTimeout(() => {
          this.insert(
            this.listItemSnackBar,
            this.listBradingDefault[Math.floor(Math.random() * 4)]
          );
        }, 3000);
      }
    }, 20000);
  },

  // beforeDestroy() {
  //   this.missionDetails = {};
  //   localStorage.removeItem("MissionDetails");
  // },

  watch: {
    shops(val) {
      console.log(val);
      // if (val.length > 0) {
      //   this.listItemSnackBar.push(...val);
      // }
    },
    showShopInfo(val) {
      if (val === null) {
        this.plyr.play();
      }
    },
    isHintItem() {
      let video = document.querySelector("#player-video");
      this.duration = video.duration;
      this._makeShowCaseMainScene();
      let progressBarElm = document.querySelector(".plyr__progress");
      if (progressBarElm) {
        let makersEls = progressBarElm.getElementsByClassName("marker");
        while (makersEls.length > 0) {
          makersEls[0].parentNode.removeChild(makersEls[0]);
        }
      }
      if (this.isHintItem) {
        for (const timeScene of this.showcaseMainScene) {
          let marker = document.createElement("div");
          marker.addEventListener("click", () => {
            this.seekVideo(timeScene);
          });
          marker.classList.add("marker");
          marker.style.left = `${(timeScene * 100) / this.duration}%`;
          progressBarElm.appendChild(marker);
        }
      } else {
        for (const timeScene of this.showcaseMainScene) {
          let marker = document.createElement("div");
          marker.addEventListener("click", () => {
            this.seekVideo(timeScene);
          });
          marker.classList.remove("marker");
        }
      }
    },
  },
  methods: {
    insert(array, element) {
      array.unshift(element);
      setTimeout(() => {
        const index = array.indexOf(element);
        if (index >= 0) {
          array.splice(index, 1);
        }
      }, 8000);
    },
    AddBrading() {
      this.insert(
        this.listItemSnackBar,
        this.listBradingDefault[Math.floor(Math.random() * 4)]
      );
    },
    applyOrientation() {
      if (window.innerHeight > window.innerWidth) {
        this.isPortrait = true;
      } else {
        this.isPortrait = false;
      }
    },
    _getMetaDataInTime(data, currentTimeVideo) {
      /*
      So sanh và get meta data tại thời điểm  hiện tại video display
      */
      return (
        _.filter(data, (o) => {
          return (
            o["itv"][0] <= currentTimeVideo && o["itv"][1] >= currentTimeVideo
          );
        }) || []
      );
    },
    showTutorial() {
      this.isShowTutorial = true;
      this.plyr.pause();
    },
    closeTutorial() {
      this.isShowTutorial = false;
      this.plyr.play();
    },
    itemHint() {
      this.isHintItem = !this.isHintItem;
    },

    onclickBuyNow(shop) {
      if (this.missionDetails.id === shop.id && !this.missionDetails.isFinish) {
        if (this.timeStartPrint.includes(shop.timeStart)) {
          return;
        }
        this.timeStartPrint.push(shop.timeStart);
        this.missionDetails.timeCount += 1;
        this.missionDetails.percent =
          (this.missionDetails.timeCount / this.missionDetails.time) * 100;
        this.itemTop = shop.y + "px";
        this.itemLeft = shop.x + "px";
        this.itemWidth = shop.width + "px";
        this.itemHeight = shop.height + "px";
        let imgProduct = document.createElement("img");
        imgProduct.src = `${shop.image}`;
        let src = document.getElementById(`${shop.id}`);
        src.appendChild(imgProduct);
        let moveElement = document.getElementById(`${shop.id}item`);
        moveElement.classList.add("animation-add-mission");

        let productCtn = document.getElementById(`${shop.id}`);
        let pyro = null;
        if (productCtn) {
          let after = document.createElement("div");
          after.classList.add("after");
          pyro = document.createElement("div");
          pyro.classList.add("pyro");
          pyro.appendChild(after);

          productCtn.appendChild(pyro);
          setTimeout(() => {
            // productCtn.removeChild(countLabel);
            productCtn.removeChild(pyro);
            pyro = null;
            // countLabel = null;
          }, 800);
        }
        setTimeout(() => {
          imgProduct.remove();
          moveElement.classList.remove("animation-add-mission");
        }, 1000);
        if (this.missionDetails.percent === 100) {
          this.missionDetails.isFinish = true;
          this.pointDetails = this.missionDetails.point;
          let pointAward =
            document.getElementsByClassName("award-point-zone")[0];
          if (pointAward) {
            pointAward.style.display = "flex";
            pointAward.classList.add("animation-point-redeem");
          }
          setTimeout(() => {
            pointAward.style.display = "none";
          }, 1000);
          let point = localStorage.getItem("totalPoint");
          if (point) {
            point = parseInt(point) + this.missionDetails.point;
            localStorage.setItem("totalPoint", point);
          } else {
            localStorage.setItem("totalPoint", this.missionDetails.point);
          }
        }
      }

      localStorage.setItem(
        "MissionDetails",
        JSON.stringify(this.missionDetails)
      );
      this.myMission = this.myMission.filter(
        (item) => item.id !== this.missionDetails.id
      );
      this.myMission.push(this.missionDetails);
      localStorage.setItem("MyMission", JSON.stringify(this.myMission));
    },
    onNextScene() {},
    onPreScene() {},
  },
};
</script>

<style lang="scss">
@import "https://cdn.plyr.io/3.6.7/plyr.css";
@import "./demo-game-ui.scss";
@import "../../../styles/player.scss";
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");
.animation-add-mission {
  animation-name: addToMisson;
  animation-duration: 1s;
  animation-iteration-count: 1;
}

@keyframes addToMisson {
  0% {
    left: v-bind(itemLeft);
    top: v-bind(itemTop);
    width: v-bind(itemWidth);
    height: v-bind(itemHeight);
    opacity: 1;
  }
  100% {
    left: 0;
    top: 40px;
    width: 0;
    height: 0;
    opacity: 0;
  }
}
.snackbar-parent {
  position: absolute;
  bottom: 50px;
  left: 5px;
  height: 200px;
  .item {
    border-radius: 5px;
    margin: 5px auto;
    list-style: none;
    transition: 0.5s;
    overflow: hidden;
    display: flex;
    font-size: 11px;
    padding: 5px;
    justify-content: flex-start;
    align-items: center;
    color: aliceblue;
    background-color: #0000003f;
    cursor: pointer;
    img {
      width: 35px;
      height: 35px;
    }
  }

  /* 
Adding animations for list items
*/
  .list-enter-active {
    animation: fade-in 1.5s ease-in-out;
  }

  .list-leave-active {
    animation: fade-in 1.5s ease-in-out reverse;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
      transform: translate(-30px);
    }
    100% {
      transform: translate(0px);
    }
  }
}
.item-snackbar {
  width: 150px;
  height: 50px;
  margin-bottom: 5px;
  background-color: #f00606cf;
}
</style>
